export default {
	namespaced: true,
	state: ()=>({
		tabs:[{
			index:"0",
			name:"首页",
			router:"myindex"
		}],
		showindex:0,
		cache:{}
	}),
	getters:{
		getalltabs(state){
			return state.tabs
		},
		getname(state){
			return state.tabs.map(e=>e.name)
		},
		getrouter(state){
			return state.tabs.map(e=>e.router)
		},
		getindex(state){
			return state.showindex
		},
		getmenuindex(state){
			return state.tabs[state.showindex].index
		},
		getCache:(state)=>(lable)=>{
			return state.cache[lable]
		}
	},
	mutations: {
		setindex(state,i){
			state.showindex=i
		},
		addtab(state,data){
			state.tabs.push(data)
			state.showindex=state.tabs.length-1
		},
		deltab(state,i){
			delete state.cache[state.tabs[i].router]
			window.cache=state.cache
			state.tabs.splice(i,1)
		},
		repshow(state,a){
			let arr=[...state.tabs]
			const obj=arr[a.i]
			arr[a.i]=arr[a.j]
			arr[a.j]=obj
			state.tabs=arr
		},
		setCache(state,data){
			if(state.tabs.find(e=>e.router===data.label)){
				state.cache[data.label]=data
			}
		},
		tabinit(state){
			state.tabs=[{index:"0",name:"首页",router:"myindex"}]
			state.showindex=0
			state.cache={}
		}
	},
	
}
